export function getDayHourMinSecFromStartTime(startTime: Date): {
    day: number,
    hour: number,
    min: number,
    sec: number ,
} {
    const countdown = (startTime.valueOf() / 1000) - (Date.now() / 1000);
    const day = Math.floor(countdown / (3600 * 24));
    const hour = Math.floor((countdown % (3600 * 24)) / 3600);
    const min = Math.floor((countdown % 3600) / 60);
    const sec = Math.floor(countdown % 60);

    return {
        day,
        hour,
        min,
        sec,
    };
}

// function to determine if the scheduled stream is at the point of no return
export function withinUnsafeTimeLeft(startTime: Date): Boolean {
    if (startTime) {
        const {
            day,
            hour,
            min,
            sec,
        } = getDayHourMinSecFromStartTime(startTime);
        return day === 0 && hour === 0 && min === 0 && sec <= 3;
    }

    return false;
}

// function to determine if the scheduled stream is starting soon
export function shouldShowStreamStartingAlert(startTime: Date): Boolean {
    if (startTime) {
        const {
            day,
            hour,
            min,
            sec,
        } = getDayHourMinSecFromStartTime(startTime);

        return day === 0 && hour === 0 && min === 0 && sec === 5;
    }

    return false;
}

export function isThirtySecondsToStart(startTime: Date) {
    const now = Date.now();
    const thirtySeconds = 30 * 1000;
    const actualStart = startTime.valueOf();
    const thirtySecondsFromStart = actualStart - thirtySeconds;

    // if the current time is between 30 seconds before the start time and the start time
    return now >= thirtySecondsFromStart && now < actualStart;
}